import React from 'react'

import { IConditionalWrapperProps } from './types'

export const ConditionalWrapper = React.forwardRef<
  HTMLElement,
  IConditionalWrapperProps
>(({ className, WrapEl, children, ...rest }, ref) => {
  const Wrap = WrapEl ? WrapEl : React.Fragment
  const props = WrapEl && WrapEl !== React.Fragment ? { className } : {}
  return (
    <Wrap {...rest} {...props} ref={ref}>
      {children}
    </Wrap>
  )
})

export * from './page'
